import React from 'react';

import fetch from '../../fetch';

import utils from '../../../utils';

const prefixUrl = "graduation/course/signup/view/"

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

const columnArray = 
[
    {type: 'selection'},
    {   
        key:'$index', 
        label: '序号',
        width: 80
    },
    {
        key: 'orgName',
        label: '所属部门',
        width: 100
    },
    {
        key: 'majorName',
        label: '开课专业',
        width: 100
    },
    {
        key: 'coursePropertiesName', 
        label: '课程性质',
        width: 100
    },
    {
        key: 'courseTypeName', 
        label: '课程类型',
        width: 100
    },
    {
        key: 'batchNo', 
        label: '批次',
        width: 100
    },
    {
        key: 'courseNum', 
        label: '课程门数',
        width: 120
    },
    {
        key: 'majorNum', 
        label: '开课专业数',
        width: 100
    },
    {
        key: 'employeeNum', 
        label: '开课教师人数',
        width: 120
    },
    {
        key: 'certifiedTeacherNum', 
        label: '认证教师人数',
        width: 100
    },
    {
        key: 'certifiedProgress', 
        label: '认证率',
        width: 100
    },
    {
        key: 'mentorNum', 
        label: '指导教师人数',
        width: 100
    },
    {
        key: 'bgTermName', 
        label: '开始学期',
        width: 100
    },
    {
        key: 'endTermName', 
        label: '结束学期',
        width: 100
    }
]

const headers = utils.columns(
    [
        {type: 'selection'},
        {   
            key:'$index', 
            label: '序号',
            width: 80
        },
        {
            key: 'orgName',
            label: '所属部门',
            width: 100
        },
        {
            key: 'courseNum', 
            label: '课程门数',
            width: 120
        },
        {
            key: 'majorNum', 
            label: '开课专业数',
            width: 100
        },
        {
            key: 'employeeNum', 
            label: '开课教师人数',
            width: 120
        },
        {
            key: 'certifiedTeacherNum', 
            label: '认证教师人数',
            width: 100
        },
        {
            key: 'certifiedProgress', 
            label: '认证率',
            width: 100
        },
        {
            key: 'mentorNum', 
            label: '指导教师人数',
            width: 100
        },
        {
            key: 'bgTermName', 
            label: '开始学期',
            width: 100
        },
        {
            key: 'endTermName', 
            label: '结束学期',
            width: 100
        }
    ]
)

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    params.push(`sort=${keywords.sort}`);
    let newArray = [] 
    let totalType = 1;
    for(var i in keywords) {
        if(i === 'totalType'){
            totalType = `${keywords[i]}`;
        }
    }
    return fetch.post(`${prefixUrl}totalQuery?` + params.join('&'), keywords)
    .then(response => {
        if (response.code === 200) {
            for(let i = 0; i < columnArray.length; i++) {
                if(totalType == 1){
                    if(columnArray[i].key != 'majorName'&& columnArray[i].key != 'coursePropertiesName'&& columnArray[i].key != 'courseTypeName'&& columnArray[i].key != 'batchNo'){
                        newArray.push(columnArray[i])
                    }
                }else if(totalType == 2){
                    if(columnArray[i].key != 'coursePropertiesName'&& columnArray[i].key != 'courseTypeName'&& columnArray[i].key != 'batchNo'){
                        newArray.push(columnArray[i])
                    }
                }else if(totalType == 3){
                    if(columnArray[i].key != 'majorName' && columnArray[i].key != 'courseTypeName'&& columnArray[i].key != 'batchNo'){
                        newArray.push(columnArray[i])
                    }
                }else if(totalType == 4){
                    if(columnArray[i].key != 'majorName'&& columnArray[i].key != 'coursePropertiesName' && columnArray[i].key != 'batchNo'){
                        newArray.push(columnArray[i])
                    }
                }else if(totalType == 5){
                    if(columnArray[i].key != 'majorName'&& columnArray[i].key != 'coursePropertiesName'&& columnArray[i].key != 'courseTypeName'){
                        newArray.push(columnArray[i])
                    }
                }
            }
            return {
                data: response.payload.data,
                headers: newArray.length > 0 ? utils.columns(newArray) :headers
            }
        }
    })
    .then(res => (
        Object.assign({
            headers: res.headers,
            result: res.data.dataList || [],
            selects: (res.data.dataList || []).map(d => ({
                value: d.id,
                checked: false,
            })),
            checked: false,
            total: res.data.total,
            pageIndex: res.data.pageNum,
            pageSize: res.data.pageSize,
            notify: (res.data.dataList || []).length ? '' : '暂无数据...'
        }))
    )
}

export default {
    getSelection: () => DataGrid.selections,
    onSelect,
    setRefresh,
    querySearch,
    headers
}